import { defineComponent as _defineComponent } from 'vue'
import { message } from "ant-design-vue"
import { ref } from "vue"

import i18n from "@/i18n"
import ProductDraftEditor from "@/modules/offers/_components/CreateOffer/components/ProductEditor/ProductDraftEditor.vue"
import { formatAttributesForRequest } from "@/modules/offers/_components/CreateOffer/utils/productAttributes"
import type { ProductForm as ProductFormValues } from "@/modules/offers/types/offers"
import {
  ChooseExistingProduct,
  ExistedProductDetails
} from "@/modules/sync/_components/ExistedProducts"
import * as productCatalogService from "@/services/productCatalogService"

export type SearchedProduct = {
  pCode: string
  title: string
  images: string[]
}

type Emits = {
  (event: "selected", product: SearchedProduct): void
  (event: "close"): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchProducts',
  emits: ["selected", "close"],
  setup(__props, { emit }: { emit: ({
  (event: "selected", product: SearchedProduct): void
  (event: "close"): void
}), expose: any, slots: any, attrs: any }) {



const productEditorRef = ref()
const showCreateProduct = ref<boolean>(false)
const isFetching = ref<boolean>(false)
const draftId = ref<string>()
const productDetails = ref()
const showProductDetails = ref<boolean>(false)
const someRequiredAttrsEmpty = ref<boolean>(false)

const handleSelectProduct = (product) => {
  emit("selected", {
    pCode: product.p_code,
    title: product.name,
    images: product.images
  })
}
const openProductCreation = () => {
  showCreateProduct.value = true
}
const closeProductForm = () => {
  draftId.value = undefined
  showCreateProduct.value = false
}
const onProductFormChanged = async (payload: Partial<ProductFormValues>) => {
  try {
    isFetching.value = true

    if (!draftId.value) {
      const { data } = await productCatalogService.createProductDraft({ payload })
      draftId.value = data.oid
    }

    const { data } = await productCatalogService.updateProductDraft({
      payload,
      oid: draftId.value
    })

    if (payload.type || payload.type === null) {
      productEditorRef.value.setAttributes(data.attributes || [])
    }
  } finally {
    isFetching.value = false
  }
}
const handleCompleteDraft = async () => {
  const form = await productEditorRef.value.getFormValues()

  if (!form) return

  someRequiredAttrsEmpty.value = false

  const attributes = formatAttributesForRequest(form.attributes, form.free_form_attributes)

  if (
    attributes.some((attr) => {
      if (Array.isArray(attr.value) ? !attr.value.length : !attr.value) return attr.is_required

      return false
    })
  ) {
    message.error(i18n.t("offers.offer_form_required_attributes_error") as string)
    someRequiredAttrsEmpty.value = true
    return
  }

  try {
    isFetching.value = true

    const product = {
      attributes: attributes
        .filter((item) => item.value !== null)
        .map((item) => ({ code: item.code, value: item.value }))
    }

    await productCatalogService.updateProductDraft({
      payload: product,
      oid: draftId.value
    })

    const { data } = await productCatalogService.completeProductDraft({
      oid: draftId.value
    })

    handleSelectProduct({
      p_code: data.p_code,
      name: form.public_title_mlang[i18n.locale],
      images: form.images.map(({ filename }) => filename)
    })

    closeProductForm()
  } finally {
    isFetching.value = false
  }
}
const onShowProductDetails = (product) => {
  productDetails.value = product
  showProductDetails.value = true
}
const onHideProductDetails = () => {
  showProductDetails.value = false
  productDetails.value = undefined
}

return { __sfc: true,emit, productEditorRef, showCreateProduct, isFetching, draftId, productDetails, showProductDetails, someRequiredAttrsEmpty, handleSelectProduct, openProductCreation, closeProductForm, onProductFormChanged, handleCompleteDraft, onShowProductDetails, onHideProductDetails, ProductDraftEditor, ChooseExistingProduct, ExistedProductDetails }
}

})